import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Tags from "@/components/management/label/tags.vue";
import CheckBox from "@/components/CheckBox.vue";
import TreeSelect from "@/components/TreeSelect.vue";
import { getDeptTree } from "@/api/managementCenter/otherApi";
import { getAllJobList } from "@/api/managementCenter/jobManage";
import chargePerson from "@/components/management/reportManage/chargePerson.vue";
import { handleSaveOrUpdate } from "@/api/managementCenter/labelManage";
export default {
  name: "addLabel",
  data: function data() {
    return {
      loading: false,
      postList: [],
      userText: "",
      userId: [],
      deptList: [],
      isShowCheck: false,
      form: {
        labelId: "",
        labelName: "",
        //标签名称
        labelType: "0",
        //标签类型
        labelDept: "",
        //所管辖部门
        deptList: [],
        //管辖部门
        postList: [],
        //可管理岗位
        userList: [],
        //管理用户
        deptName: "" //部门中文名，便于详情回显

      },
      form2: {
        labelName: "" //标签名称

      },
      rules: {
        labelName: [{
          required: true,
          message: "请输入标签名称",
          trigger: "blur"
        }],
        deptList: [{
          required: true,
          message: "请选择部门",
          trigger: "change"
        }],
        postList: [{
          required: true,
          message: "请选择可管理岗位",
          trigger: "blur"
        }]
      },
      rules2: {
        labelName: [{
          required: true,
          message: "请输入标签名称",
          trigger: "blur"
        }],
        cond: [{
          required: true,
          message: "请选择新增标签",
          trigger: "change"
        }]
      },
      tagsRulesShow: false,
      tagsRulesShowL: false,
      jobList: [],
      personData: {
        userData: [],
        state: false,
        disabled: false,
        data: []
      },
      mapKey: {
        id: "id",
        // ID
        label: "name",
        // 显示名称
        children: "children" //子级字段名

      },
      departmentData: [],
      tagsData: [] //新增动态标签数据

    };
  },
  components: {
    TreeSelect: TreeSelect,
    CheckBox: CheckBox,
    Tags: Tags,
    chargePerson: chargePerson
  },
  mounted: function mounted() {
    this.getJobListFn();
    this.getDeptTreeData();
  },
  methods: {
    //动态静态切换
    handleClick: function handleClick() {
      // if(this.form.labelType== '1'){
      //     this.$refs['ruleForm'].resetFields()
      // }
      this.tagsRulesShow = false;
      this.form.labelName = "";
      this.form2.labelName = "";
      this.userText = "";
    },
    // 获取新增动态标签数据
    setTagsData: function setTagsData(val) {
      if (val.length == 0) {
        this.tagsRulesShow = true;
      } else {
        this.tagsRulesShow = false;
      }

      this.tagsData = val;
    },
    //获取岗位数据
    getJobListFn: function getJobListFn() {
      var _this = this;

      getAllJobList().then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          _this.jobList = data.data.map(function (item) {
            return {
              id: item.postId,
              name: item.postName
            };
          }) || [];
        } else {
          _this.$message.warning(data.msg || "获取岗位失败！");
        }
      }).catch(function (err) {});
    },
    //获取部门数据
    getDeptTreeData: function getDeptTreeData() {
      var _this2 = this;

      getDeptTree().then(function (_ref2) {
        var data = _ref2.data;

        if (data.code == 0) {
          if (data.data && data.data.length > 0) {
            if (data.data[0].id == 1) {
              _this2.departmentData = data.data[0].children;
            } else {
              _this2.departmentData = data.data;
            }
          }
        }
      }).catch(function (err) {});
    },
    setDeptDoubleMenu: function setDeptDoubleMenu(key, data) {
      //获取子组件值
      // this.doubleSelect = data.map(item=>item.id)
      if (key.length == 0) {
        this.$refs["ruleForm"].validateField("deptList");
        this.form.deptList = [];
        this.form.deptName = [];
      } else {
        this.$refs["deptListv"].resetField();
        this.form.deptList = key.map(function (item) {
          return {
            labelId: "",
            deptId: item.toString()
          };
        });
        this.form.deptName = data.map(function (item) {
          return item.name;
        });
      }
    },
    //获取复选框数据
    setCheckValue: function setCheckValue(ids, value) {
      if (ids.length == 0) {
        this.$refs["ruleForm"].validateField("postList");
        this.postList = [];
        this.userText = "";
      } else {
        this.$refs["postListv"].resetField();
        this.postList = ids;
        this.userText = value.toString();
      }
    },
    setCkeckShow: function setCkeckShow(value) {
      this.isShowCheck = value;
    },
    saveOrUpdate: function saveOrUpdate() {
      var _this3 = this;

      this.loading = true;
      var params = {
        deptList: this.form.deptList,
        labelName: this.form.labelName,
        labelType: this.form.labelType,
        postList: this.form.postList
      };
      handleSaveOrUpdate(params).then(function (_ref3) {
        var data = _ref3.data;
        _this3.loading = false;

        if (data.code == 0) {
          _this3.$message.success("保存成功!");

          _this3.$emit("saveSuccess");
        } else {
          _this3.$message.warning(data.msg || "保存失败!");
        }
      }).catch(function (err) {
        _this3.loading = false;

        _this3.$message.error("服务器异常!");
      });
    },
    // 静态标签提交
    submitForm0: function submitForm0(formName) {
      var _this4 = this;

      if (this.form.deptList.length == 0) {
        this.$refs["deptListv"].resetField();
      }

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.saveOrUpdate();
        } else {
          return false;
        }
      });
    },
    nameChange: function nameChange() {
      if (this.form2.labelName == "") {
        this.tagsRulesShowL = true;
      } else {
        this.tagsRulesShowL = false;
      }
    },
    //动态标签提交
    submitForm1: function submitForm1() {
      var _this5 = this;

      if (this.form2.labelName == "") {
        this.tagsRulesShowL = true;
      }

      if (this.tagsData.length == 0) {
        this.tagsRulesShow = true;
        return;
      } else {
        this.tagsRulesShow = false;
      }

      if (this.form2.labelName != "" && this.tagsData.length > 0) {
        var params = {
          labelType: this.form.labelType,
          labelName: this.form2.labelName,
          labelConditions: JSON.stringify({
            conditions: this.tagsData
          })
        };
        handleSaveOrUpdate(params).then(function (_ref4) {
          var data = _ref4.data;
          _this5.loading = false;

          if (data.code == 0) {
            _this5.$message.success("保存成功!");

            _this5.$emit("saveSuccess");
          } else {
            _this5.$message.warning(data.msg || "保存失败!");
          }
        }).catch(function (err) {
          _this5.loading = false;

          _this5.$message.error("服务器异常!");
        });
      }
    },
    //显示人员选择
    addUser: function addUser() {
      this.personData.state = true;
    },
    //选择人员
    closePerson: function closePerson(value) {
      if (!value.mans) {
        this.personData.state = false;
        return;
      }

      var mans = value.mans || [];
      this.userText = mans.map(function (item) {
        return item.name;
      }).join("、");
      this.userId = mans.map(function (item) {
        return item.userId;
      });
      this.personData.state = false;
    }
  },
  watch: {
    postList: function postList(val) {
      this.form.postList = (val || []).map(function (i) {
        return {
          postId: i
        };
      });
    },
    userId: function userId(val) {
      this.form.userList = (val || []).map(function (i) {
        return {
          userId: i
        };
      });
    }
  }
};